import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { EligibilityControllerApi } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../utils/utils";

interface UseGetEligibilityByUuidProps {
  eligibilityUuid?: string;
}

/**
 *
 * @author Atish Bagate
 */
export function useGetEligibilityByUuid({
  eligibilityUuid,
}: UseGetEligibilityByUuidProps): useBaseContent<any> {
  return useQuery({
    queryKey: ["get-eligibility-by-uuid", eligibilityUuid],
    enabled: !!eligibilityUuid,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new EligibilityControllerApi(getConfigObject())
        .getEligibility(eligibilityUuid!, getXtenantId())
        .then((res) => res?.data),
  });
}
